import { createSlice } from "@reduxjs/toolkit";

const cartaretencionState = {
  datacartaretencion: ""
}

export const cartaretencionSlice = createSlice({
  name: "cartaretencion",
  initialState: cartaretencionState,
  reducers: {
    StoreCartaRetencionData: (state, actions) => {
      state.cartaretencionState = actions.payload;
    },
    ResetCartaRetencionData: () => cartaretencionState,
  }
});

export const { StoreCartaRetencionData, ResetCartaRetencionData } = cartaretencionSlice.actions;

export default cartaretencionSlice.reducer;